import { render } from "./InterventoDetail.vue?vue&type=template&id=56fa4b71&scoped=true&ts=true"
import script from "./InterventoDetail.vue?vue&type=script&lang=ts"
export * from "./InterventoDetail.vue?vue&type=script&lang=ts"

import "./InterventoDetail.vue?vue&type=style&index=0&id=56fa4b71&scoped=true&lang=css"

import exportComponent from "/Users/michael/Sites/firegui_multilink_app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fa4b71"]])

export default __exports__